import { render, staticRenderFns } from "./PatientMatchingPopup.vue?vue&type=template&id=3bf749f6&scoped=true&"
import script from "./PatientMatchingPopup.vue?vue&type=script&lang=js&"
export * from "./PatientMatchingPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf749f6",
  null
  
)

export default component.exports